import NeptuneElement from '../../NeptuneElement.js';

class Button extends NeptuneElement {

    static BUTTON_TYPES = [
        'primary',
        'secondary',
        'tertiary',
        'flat',
        'destructive',
        'destructive-outline'
    ];

    static BUTTON_SIZES = [
        'large',
        'default',
        'small',
        'full-width'
    ];

    templateMarkup = `
        <button type="button">
            <i class="fa-regular" hidden></i><slot></slot><i class="fa-solid" hidden></i>
        </button>
    `;

    componentCssUrl = '/src/components/core/button/button.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();

        this.validateRequiredProperties(['type', 'size']);
        this.processInitialAttributesAfterRender(Button.observedAttributes);
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['type', 'size', 'icon-start', 'icon-end', 'disabled'];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (!this.isRendered) {
            return;
        }

        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {

        switch (name) {
            case 'type': {
                this.validatePropertyValue(name, newValue, Button.BUTTON_TYPES);
                break;
            }
            case 'size': {
                this.validatePropertyValue(name, newValue, Button.BUTTON_SIZES);
                break;
            }
            case 'icon-start': {
                let leftIcon = this.shadowRoot.querySelectorAll('.fa-regular')[0];
                if (newValue) {
                    leftIcon.className = `fa-regular ${newValue}`;
                    leftIcon.removeAttribute('hidden');
                } else {
                    leftIcon.className = 'fa-regular';
                    leftIcon.setAttribute('hidden', '');
                }
                break;
            }
            case 'icon-end': {
                let rightIcon = this.shadowRoot.querySelectorAll('.fa-solid')[0];
                if (newValue) {
                    rightIcon.className = `fa-solid ${newValue}`;
                    rightIcon.removeAttribute('hidden');
                } else {
                    rightIcon.className = 'fa-solid';
                    rightIcon.setAttribute('hidden', '');
                }
                break;
            }
            case 'disabled': {
                let buttonElement = this.shadowRoot.querySelector('button');

                let isDisabled = this.hasAttribute('disabled');

                if(isDisabled) {
                    buttonElement.setAttribute('disabled', 'true');
                } else {
                    buttonElement.removeAttribute('disabled');
                }

                break;
            }
            default: {
                break;
            }
        }
    }
}

customElements.define('neptune-button', Button);
export default Button;